import get from 'lodash/get';

const styles = ({ breakpoint, color, margin, typography, padding, lineHeight }) => ({
  listContainer: {
    paddingTop: '0 !important',
  },
  list: {
    margin: 0,
  },
  fieldContainer: {
    margin: `${get(margin, 'm0')} !important`,
    marginRight: `${get(margin, 'm8')} !important`,
  },
  sortContainerClass: {
    padding: '10px 0',
    width: '100%',
    '& button': {
      lineHeight: get(lineHeight, 'lh20'),
    },
    '& .MuiButton-outlinedPrimary:hover': {
      backgroundColor: `${get(color, 'primaryButtonBackground')} !important`,
      color: get(color, 'primaryButtonText'),
    },
  },
  buttonContainer: {
    paddingLeft: get(padding, 'p16'),
  },
  headerButtons: {
    marginTop: get(margin, 'm5'),
    marginBottom: get(margin, 'm10'),
  },
  helpIcon: {
    color: color.primaryButtonBackground,
    marginLeft: 6,
    marginTop: 3,
    height: 16,
    width: 16,
  },
  helpIconContainer: {
    display: 'flex',
  },
  roleDropdownContainer: {
    marginBottom: -9,
    marginTop: -9,
    paddingBottom: 6,
    paddingTop: 6,
    width: 250,
  },
  bulkActionsPanel: {
    display: 'flex',
  },
  bulkRoleDropdown: {
    width: 50,
  },
  addButton: {
    margin: `0 ${get(margin, 'm10')}`,
    marginTop: 30,
  },
  removeButton: {
    backgroundColor: get(color, 'error'),
    borderColor: get(color, 'error'),
    margin: `0 ${get(margin, 'm2')}`,
    '&:hover': {
      backgroundColor: get(color, 'errorHover'),
    },
    marginTop: 30,
  },
  tooltipContainer: {
    backgroundColor: get(color, 'gray'),
    padding: get(padding, 'p5'),
    borderRadius: get(padding, 'p10'),
    marginLeft: get(margin, 'm4'),
  },
  activeButton: {
    textTransform: 'none',
    color: get(color, 'primaryButtonText'),
    backgroundColor: get(color, 'primaryButtonBackground'),
    borderColor: get(color, 'primaryButtonBackground'),
    lineHeight: get(lineHeight, 'lh20'),
  },
  submitButton: {
    marginLeft: '80px !important',
  },
  dialogContainer: {
    height: 640,
  },
  dialogActionClass: {
    justifyContent: 'flex-start',
  },
  actionsLabel: {
    color: get(color, 'bodyText'),
    fontFamily: get(typography, 'bodyText'),
    fontWeight: 700,
    paddingLeft: 0,
  },
  defaultButton: {
    padding: 0,
    justifyContent: 'flex-start',
    height: '10px',
  },
  switchAccess: {
    height: '20px',
    '& .MuiSwitch-root': {
      height: '23px',
      display: 'inline-flex',
    },
  },
  [`@media (max-width: ${get(breakpoint, 'sm')})`]: {
    tagButtons: {
      marginTop: 0,
    },
  },
  noMargin: {
    margin: '0px !important',
    height: '26px !important',
    width: '200px !important',
  },
});

export default styles;
